// DeleteConfirmModal.js
import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const DeleteConfirmModal = ({ isOpen, toggle, onConfirm, title }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Confirm Delete</ModalHeader>
      <ModalBody>
        <p>{title || "Are you sure you want to delete this item?"}</p>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={onConfirm}>Delete</Button>{" "}
        <Button color="secondary" onClick={toggle}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteConfirmModal;
